import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchAddClient = async (
  projectId,
  targetOrganizationChartItemId,
  clientBusinessId,
  activeEmployerInfo
) => {
  const apiPath = `organization-charts/project/${projectId}/add-client`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      targetOrganizationChartItemId,
      clientBusinessId,
    },
    activeEmployerInfo: activeEmployerInfo,
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data;
};
